import React from "react";
import styled from "styled-components";
import useSetting from "../../hooks/useSetting";

// The glass: a slight CRT treatment over the entire viewport — faint
// scanlines and a soft corner vignette. Restrained; it should register
// subliminally, never announce itself or hurt text. Strength lives in
// Settings (0 = off, 1 = default, up to 1.4). Dev knob: ?crt=0 disables.
export const CRT_KEY = "saat.crtStrength";

function CrtOverlay() {
  const [strength] = useSetting(CRT_KEY, 1);
  if (
    typeof window !== "undefined" &&
    new URLSearchParams(window.location.search).get("crt") === "0"
  ) {
    return null;
  }
  if (!(strength > 0)) return null;
  return (
    <Glass
      aria-hidden="true"
      style={{ "--crt": Math.min(1.4, strength) }}
    />
  );
}

const Glass = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9000;
  pointer-events: none;
  opacity: var(--crt, 1);

  /* Scanlines: 1px whisper every 3px. */
  background-image: repeating-linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.06) 0px,
    rgba(0, 0, 0, 0.06) 1px,
    transparent 1px,
    transparent 3px
  );

  /* Corner vignette, barely there. */
  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: radial-gradient(
      ellipse at center,
      transparent 56%,
      rgba(10, 10, 35, 0.13) 88%,
      rgba(10, 10, 35, 0.28) 100%
    );
  }
`;

export default CrtOverlay;
